// extracted by mini-css-extract-plugin
export default {"iconContainer":"AuthProfileTypeIcon_iconContainer__x7uWP"};